import React from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import { Page } from '@templates'

import { FadeIn, LoadingComponent, TextContainer } from './styles'

interface CarregamentoLayoutProps {
  lembrete: string
  size: string
  backgroundColor: string
}

const CarregamentoLayout: React.FC<CarregamentoLayoutProps> = ({
  lembrete,
  size,
  backgroundColor,
}) => (
  <Page
    showLeftIcon={false}
    footerTwoButtonsSpace="300px"
    stickyFooter={
      <>
        <TextContainer size={size}>
          <FadeIn>
            <Text variant="headline-h1" colorWeight={500}>
              {lembrete}
            </Text>
          </FadeIn>
        </TextContainer>
        <LoadingComponent size={size} backgroundColor={backgroundColor} />
      </>
    }
  >
    <div />
  </Page>
)

export default CarregamentoLayout
